import BookingCollectionDesktop from './BookingCollectionDesktop';

export default BookingCollectionDesktop;
